export default __webpack_public_path__ + "static/media/sputnik-group.d3596d5b.png";